/**
 * Azerbaijani manat.
 */
export var AZN = {
  code: 'AZN',
  base: 10,
  exponent: 2
};